var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.editorContent}}),_vm._v(" "),_c('ckeditor',{staticClass:"editor-border",attrs:{"required":_vm.required,"editor":_vm.editor,"config":_vm.editorConfig},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }